<section class="operations-page">
    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading analytics capabilities…</p>
    </div>

    <div class="operations-page__card operations-page__card--error" *ngIf="!loading && errorMessage">
        <p>{{ errorMessage }}</p>
    </div>

    <section class="operations-page__card" *ngIf="!loading && !errorMessage">
        <h2 class="operations-page__heading">
            {{ showImplementationDetails ? 'Platform analytics registry' : 'Available capabilities' }}
        </h2>
        <p class="operations-page__section-lead">
            <ng-container *ngIf="showImplementationDetails">
                Analytics are rendered dynamically from the backend registry. Do not hardcode capability names in the
                UI.
            </ng-container>
            <ng-container *ngIf="!showImplementationDetails">
                Capabilities available for your organization. Contact your administrator to enable or disable them.
            </ng-container>
        </p>

        <div class="operations-page__empty operations-page__empty--inline" *ngIf="!displayDefinitions.length">
            No analytics capabilities are registered.
        </div>

        <div class="operations-table-wrapper" *ngIf="displayDefinitions.length">
            <table class="operations-table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th *ngIf="showImplementationDetails">Key</th>
                    <th *ngIf="showImplementationDetails">Provider</th>
                    <th *ngIf="showImplementationDetails">Output fact</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let definition of displayDefinitions">
                    <td>
                        <strong>{{ showImplementationDetails ? definition.name : customerAnalyticsName(definition)
                            }}</strong>
                        <small *ngIf="customerAnalyticsDescription(definition) as description">{{ description }}</small>
                    </td>
                    <td *ngIf="showImplementationDetails"><code>{{ definition.analytics_key }}</code></td>
                    <td *ngIf="showImplementationDetails">{{ implementationProviderLabel(definition.provider) }}</td>
                    <td *ngIf="showImplementationDetails"><code>{{ definition.output_fact }}</code></td>
                    <td>
                        <span class="analytics-definitions__badge"
                              [class.analytics-definitions__badge--active]="definition.is_active">
                            {{ definition.is_active ? 'Active' : 'Inactive' }}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </section>
</section>
